import { useState } from "@wordpress/element";
import { Dashicon } from '@wordpress/components';
import calculatorTypes from "../../../../assets/types-cal.json";

const Siliconas = ({ posts, typeCalc }) => {

    const classNameSpace = 'c-simple-cal';
    const [selectedOption, setSelectedOption] = useState('');

    const [anchoJunta, setAnchoJunta] = useState('');
    const [profunndidad, setProfunndidad] = useState('');

    const [contenido, setContenido] = useState(1);
    const [productSelected, setproductSelected] = useState('');
    const [showResult, setShowResult] = useState('');
    const [showCalc, setShowCalc] = useState('has-show-form');

    const calOptions = calculatorTypes.filter( e => e.value == typeCalc ).map(e=>e.label)[0];

    const filterProduct = (e) =>{
        const productSelect = posts.filter( selected => e.target.value == selected.slug)[0];  
        const getPresentation = productSelect.block_data.filter( element =>{
            return element.name = 'plm/product-sizes'
        });


        setSelectedOption(e.target.value);
        setproductSelected(productSelect);
        setContenido(getPresentation[1].attrs.presentations[0].value);
    }

    const showResults = () =>{
        setShowResult('has-show-results');
        setShowCalc('');
    }

    const backForInfo = () =>{
        setShowResult('');
        setShowCalc('has-show-form');
    }


	return (
        <section className={classNameSpace+'__content'}>
            <div className={classNameSpace+'__select-product'}>
                <div className={classNameSpace + '__step-one'}>
                    <div className={classNameSpace + '__title-calc'}>
                        <h2 className={classNameSpace + '__title'}> 
                            <strong className='number-step'>1</strong> Seleccionar producto de <br/> {calOptions}
                        </h2>
                    </div>
                    <div className={classNameSpace + '__product-selec'}>

                        <select  className={classNameSpace + '__selector'} 

                            value={selectedOption} 
                                onChange={(e) => { filterProduct(e) }
                            }

                        >
                            <option value='0'>Selecciona un producto</option>
                        {posts.map((option) => (
                            <option key={option.ID} value={option.slug}>
                                {option.title}
                            </option>
                        ))}
                        </select>

                    </div>
                    { productSelected != 0 &&
                        <div className={classNameSpace + '__product'}>
                            <img 
                                style={{width:"150px", height:"150px"}} 
                                className={classNameSpace + '__img'} src={productSelected.featured_medium} 
                            />
                            <h3 className={classNameSpace + '__product-title'}>{productSelected.title}</h3>
                        </div>
                    }
 
                    

                </div>
            </div>
            { productSelected != 0 &&
                <div className={classNameSpace+'__select-dimenction'}>
                    
                    <>
                        <div  className={classNameSpace+'__step-two '+showCalc}>
                            <div className={classNameSpace + '__title-calc'}>
                                <h3 className={classNameSpace + '__title'}>
                                    <strong className='number-step'>2</strong>
                                    Dimensiones y medidas
                                </h3>
                                <h4 className={classNameSpace + '__area-title'}>Área total</h4>
                                <div className={classNameSpace + '__area-input'}>

                                    <input
                                        className={classNameSpace + '__element'} 
                                        placeholder="Ancho de junta en mm"
                                        type="text"
                                        value={anchoJunta}
                                        onChange={event => setAnchoJunta(event.target.value)}
                                    />

                                    <input
                                        className={classNameSpace + '__element'} 
                                        placeholder="Profundidad de la junta en mm"
                                        type="text"
                                        value={profunndidad}
                                        onChange={event => setProfunndidad(event.target.value)}
                                    />
                                    
                                </div>
                                
                                <small className={classNameSpace + '__help'}>
                                    * Seprar solo por puntos
                                </small>

                                {anchoJunta && contenido && profunndidad &&
                                    <div 
                                        className={classNameSpace + '__btn-calcular'}
                                        onClick={showResults}
                                    >
                                        <p className={classNameSpace + '__calcular-text'}>Calcular <Dashicon icon="arrow-right-alt" /></p>
                                    </div>
                                }
                            </div>
                        </div>
                        
                        <div className={classNameSpace+'__result '+showResult}>
                            {anchoJunta && contenido && profunndidad &&
                                <>
                                    <h3 className={classNameSpace+'__result-title'}>
                                        { 'Necesitas ' +  
                                           ((contenido/(anchoJunta*profunndidad)).toFixed(1)) + 
                                           ' metros lineales por cartucho'
                                        } 
                                    </h3>
                                    {/* <h3 className={classNameSpace+'__result-title'}>de {produtPresentation}</h3> */}
                                    <h4 className={classNameSpace+'__result-rend'}>Contenido en militros</h4>
                                    <p className={classNameSpace+'__result-text'}>{contenido}</p>
                                    <p className={classNameSpace+'__result-text'}>
                                        {productSelected.block_data[1].attrs.rend_descripcion}
                                    </p>
                                    <h4 className={classNameSpace+'__result-rend'}>Ancho de junta</h4>
                                    <p className={classNameSpace+'__result-text'}>{anchoJunta}</p>

                                    <h4 className={classNameSpace+'__result-rend'}>Profundidad de junta</h4>
                                    <p className={classNameSpace+'__result-text'}>{profunndidad}</p>
                                    <div className={classNameSpace+'__result-nota'}>
                                        <p className={classNameSpace+'__p-nota'}>
                                            Este resultado es una cantidad aproximada, de igual forma te recomendamos que vayas a una de nuestras Tiendas Pintuco, haz clic y encuentra la más cercana aqui. Si deseas más información contáctanos por el chat o escríbenos contacto
                                        </p>
                                    </div>
                                    <p className={classNameSpace+'__back-calculate'}
                                        onClick={backForInfo}
                                    ><Dashicon icon="arrow-left-alt" />Volver a Calcular</p>
                                </>
                            }             
                        </div>
                    </>
                </div>
            }              

        </section>
    )
}

export default Siliconas;